export default __webpack_public_path__ + "static/media/agency.f6e98f24.svg";